import axiosInstance from './axiosInstance';
import OnlineUser from "../types/OnlineUser";

export const fetchOnlineUsers = async (): Promise<{ users: OnlineUser[] } | void> => {
    return axiosInstance.get<{ users: OnlineUser[] }>("/users/online")
        .then(response => response.data)
        .catch(error => console.error("ERROR", error))
}
